import React, { createContext, useContext, useMemo, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const SESSION_KEY = "mvandora-order-authenticated";
const ORDER_USERNAME = "admin";
const ORDER_PASSWORD = "admin123";

const OrderAuthContext = createContext(null);

function getInitialAuthState() {
  if (typeof window === "undefined") return false;
  return window.sessionStorage.getItem(SESSION_KEY) === "true";
}

export function OrderAuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(getInitialAuthState);

  const value = useMemo(
    () => ({
      isAuthenticated,
      login(username, password) {
        const isValid =
          username === ORDER_USERNAME && password === ORDER_PASSWORD;
        if (isValid) {
          window.sessionStorage.setItem(SESSION_KEY, "true");
          setIsAuthenticated(true);
        }
        return isValid;
      },
      logout() {
        window.sessionStorage.removeItem(SESSION_KEY);
        setIsAuthenticated(false);
      },
    }),
    [isAuthenticated]
  );

  return (
    <OrderAuthContext.Provider value={value}>
      {children}
    </OrderAuthContext.Provider>
  );
}

export function useOrderAuth() {
  const context = useContext(OrderAuthContext);
  if (!context) {
    throw new Error("useOrderAuth must be used within OrderAuthProvider");
  }
  return context;
}

export function RequireOrderAuth({ children }) {
  const { isAuthenticated } = useOrderAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/order-login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return children;
}
